<template lang="pug">
    div
        barcode-scanner-handler(@codescanned="scannerHandler($event)" v-if="!ticketIsValid")
        //v-toolbar(:color="colors.primary" dark)
            actions-menu
        v-container(fluid grid-list-md)
            v-layout(fill-height)
                v-flex(:md7="displayDetail" :md12="!displayDetail")
                    v-card.elevation-20(pa-3)
                        v-card-text
                            v-layout(row wrap)
                                v-flex(md12 sm12 xs12)
                                    v-switch(
                                        label="Ticket Múltiples"
                                        v-model='multipleTicket'
                                        :disabled="disabledMultipleTicketSwitch"
                                        )
                                v-flex(md12 sm12 xs12)
                                    .headline Código Ticket Venta (F6)
                                v-flex(:md12="!displayDetail" :md11="displayDetail")
                                    v-text-field.headline#sale-ticket-input(
                                        v-show="!multipleTicket"
                                        persistent-hint
                                        ref="ticketInput"
                                        label="Código ticket venta"
                                        hint="Use la pistola para leer código de barra o ingrese código manualmente"
                                        v-model="ticketRead"
                                        @keyup.enter.stop="readTicketCode(ticketRead)"
                                        :disabled="blockSearch"
                                        :readonly="ticketCode!=''")
                                v-flex(:md12="!displayDetail" :md11="displayDetail")
                                    v-text-field.headline#sale-ticket-input(
                                        v-show="multipleTicket"
                                        persistent-hint
                                        ref="ticketInput"
                                        label="Código ticket venta"
                                        hint="Use la pistola para leer código de barra o ingrese código manualmente"
                                        v-model="ticketRead"
                                        :disabled="blockSearch"
                                        @keyup.enter="readTicketCode(ticketRead)"
                                        )
                                //- v-flex(:md12="!displayDetail" :md11="displayDetail")
                                //-     v-select(
                                //-         v-show="multipleTicket"   
                                //-         v-model='chips' 
                                //-         label='Código ticket venta' 
                                //-         chips='' 
                                //-         tags='' 
                                //-         hint="Use la pistola para leer código de barra o ingrese código manualmente"
                                //-         clearable=''
                                //-         persistent-hint
                                //-         @keyup.enter="readTicketCodeChip(chips)"
                                //-         )
                                //-         template(slot='selection' slot-scope='data')
                                //-             v-chip(:selected='data.selected' close='' @input='remove(data.item)')
                                //-                 strong {{ data.item }}
                                //-                 //- span ($400.000)
                                v-flex(v-if='displayDetail' md1)
                                    v-btn(flat icon :color="colors.dangers" @click="cleanTicket")
                                        v-icon close
                                v-flex(:md12="!displayDetail" :md11="displayDetail")
                                    multiple-ticket(v-show="multipleTicket" @deleteMultipleSaleTicket='removeChip($event)')
                        v-divider
                        v-card-text(v-if="ticketIsValid")
                            v-fade-transition
                                payment(v-if="ticketIsValid" @clean-form="cleanForm" @paymentSuccess="multipleTicket=false")
                v-slide-x-reverse-transition    
                    v-flex(md5  v-show="items !=null" )
                        v-card.elevation-20(style="height: 100%;")
                            sale-detail
 
</template>

<script>
// import ActionsMenu from '@/components/ActionsMenu/ActionsMenu'
import SaleDetails from '@/components/CashDesk/Detail/SaleDetails'
import Payment from '@/components/CashDesk/Payment/Payment'
import BarcodeScannerHandler from '@/components/BarcodeScannerHandler/BarcodeScannerHandler'
import { mapState, mapActions, mapGetters } from 'vuex'
import { log } from 'util'
import PosSale from '@/models/POS/PosSale'
import {
    ANNUL_SALE_ACTION,
    CLEAN_TICKET,
} from '@/components/SnackbarModal/SnackbarActions'
import { timingSafeEqual } from 'crypto'
import {
    getIntegrationTicketNumber,
    getIntegrationInvoiceTicketNumber,
} from '../../services/API/Integration'
import MultipleTicket from '../../components/MultipleTicket/MultipleTicket'
import MultipleTicketTotalServices from '../../services/API/multiplePaymentTicket/multiplePaymentTicket'
import { clone, debounce } from 'lodash'
const SC = 'SC'
const SE = 'SE'
export default {
    name: 'cash-desk',
    props: {},
    data: function() {
        return {
            ticketRead: 'SC',
            ticketIsValid: false,
            multipleTicket: false,
            chips: [], //['SC000000001', 'SC000000002', 'SC000000003'],
            blockSearch: false,
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            items: 'saleDetail',
            ticketCode: 'ticketCode',
            payer: 'payer',
            multipleSaleTicket: 'multipleSaleTicket',
            posSaleType: 'posSaleType',
            customerId: 'customerId',
            arrayPayments: 'arrayPayments',
        }),
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        ...mapState('AuthModule', ['cash_desk_id']),
        ...mapGetters('CashDeskModule', {
            currentLines: 'currentLines',
            currentDiscountOrChargePercentage:
                'currentDiscountOrChargePercentage',
            currentIdMultiTicket: 'currentIdMultiTicket',
        }),
        disabledMultipleTicketSwitch() {
            return (
                !!(
                    this.multipleSaleTicket &&
                    this.multipleSaleTicket.length > 1
                ) ||
                !!(this.arrayPayments && this.arrayPayments.length) ||
                (!!this.multipleSaleTicket &&
                    !!this.multipleSaleTicket.length &&
                    !!this.multipleSaleTicket[0].changed_dte &&
                    !!this.multipleSaleTicket[0].changed_dte.dte_number)
            )
        },
        displayDetail: function() {
            return this.items != null ? true : false
        },
    },
    methods: {
        scannerHandler(code) {
            //alert(code)
            this.ticketRead = code
            this.readTicketCode(code)
        },

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            initSnackbar: 'initSnackbar',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        //FIXME: REMOVE IN PRODUCTION
        ...mapActions('IntegrationModule', {
            setTicketCounter: 'setTicketCounter',
            setInvoiceTicketCounter: 'setInvoiceTicketCounter',
            setOfficeID: 'setOfficeID',
        }),
        //ENDFIXME

        ...mapActions('CashDeskModule', {
            setSale: 'setSale',
            resetCashDeskState: 'resetCashDeskState',
            fetchSaleCustomer: 'fetchSaleCustomer',
            annulSale: 'annulSale',
            setPayer: 'setPayer',
            deletePrefix: 'deletePrefix',
            fetchSaleEmployee: 'fetchSaleEmployee',
            resetSale: 'resetSale',
            addMultipleSaleTicket: 'addMultipleSaleTicket',
            resetSaleAfterRemoveTicket: 'resetSaleAfterRemoveTicket',
            setSaleType: 'setSaleType',
            setIsChangeTicket: 'setIsChangeTicket',
            setSwitchMultipleTicket: 'setSwitchMultipleTicket',
        }),

        ...mapActions('CustomerModule', {
            setCustomerData: 'setCustomerData',
            resetCostumerState: 'resetCostumerState',
            setCoreBusinessCustomer: 'setCoreBusinessCustomer',
            setSelectedOffice: 'setSelectedOffice',
            setCustomerReadonly: 'setCustomerReadonly',
            setCustomerPaymentConditionId: 'setCustomerPaymentConditionId',
        }),
        ...mapActions('AuthModule', ['fetchCashDeskID']),

        readTicketCode: debounce(function(codeString) {
            this.resetSnackbarState()
            //this.resetCostumerState()

            if (this.checkPrefixTicket(codeString)) {
                let code = clone(codeString)

                this.setPayer(clone(code))
                //get code without prefix
                let newCode = this.deletePrefix(clone(code)).then(response => {
                    if (!this.checkExistIdInMultipleTicket(response)) {
                        this.getSale(response)
                        if (this.multipleTicket) {
                            this.ticketRead = ''
                            //his.ticketIsValid = false
                        }
                    } else {
                        this.resetSnackbarState()
                        let snackInfo = this.fillSnack(
                            'warning',
                            `Ingreso No permitido(Ticket Ya ingresado)`,
                            `No se puede ingresar el mismo ticket`
                        )
                        this.initSnackbar(snackInfo)
                        this.ticketRead = ''
                    }
                })
            } else {
                this.ticketRead = ''
            }
        }, 1000),
        readTicketCodeChip(chipCodeArray) {
            this.resetSnackbarState()
            this.resetCostumerState()
            //setear payer
            //alert(code)
            let code = this.getLastTicketAdded(chipCodeArray)
            this.setPayer(chipCodeArray[0])
            //get code without prefix
            let newCode = this.deletePrefix(code).then(response => {
                this.getSale(response)
            })
        },

        async getSale(code) {
            this.blockSearch = true
            let snackInfo = this.fillSnack(
                'info',
                `Buscando Ticket`,
                'Espere un momento...',
                true
            )
            this.initSnackbar(snackInfo)
            let stateSaleId = null
            let data = null
            const State = [
                { id: 17, status: 'Ok para realizar venta' },
                { id: 18, status: 'Venta Anulada' },
                { id: 19, status: 'Venta ya ejecutada' },
            ]
            if ([this.payer, this.payer.toUpperCase()].includes(SE)) {
                //TODO: Set new data after backend fixes
                try {
                    data = await this.fetchSaleEmployee(code)
                } catch (e) {
                    let message =
                        e.response && e.response.data && e.response.data
                            ? e.response.data.message
                                ? e.response.data.message
                                : e.response.data.error
                                ? e.response.data.error
                                : e
                            : e
                    let payload = {
                        typeMessage: 'error',
                        message: {
                            title: 'Error',
                            body: message,
                        },
                        timeout: 0,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)
                    this.blockSearch = false
                }
                stateSaleId = data.g_state_id
            } else {
                try {
                    data = await this.fetchSaleCustomer(code)
                    if (data.g_core_business_sii_id) {
                        this.setCoreBusinessCustomer(
                            data.g_core_business_sii_id
                        )
                    }
                    if (data.sl_customer_branch_offices_id) {
                        this.setSelectedOffice(
                            data.sl_customer_branch_offices_id
                        )
                    }
                } catch (e) {
                    let message =
                        e.response && e.response.data && e.response.data
                            ? e.response.data.message
                                ? e.response.data.message
                                : e.response.data.error
                                ? e.response.data.error
                                : e
                            : e
                    let payload = {
                        typeMessage: 'error',
                        message: {
                            title: 'Error',
                            body: message,
                        },
                        timeout: 0,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)
                    this.blockSearch = false
                }
                stateSaleId = data.g_state_id
                if (
                    data.changed_dte &&
                    data.changed_dte.dte &&
                    data.changed_dte.dte.total
                ) {
                    let tot = data.changed_dte.is_ticket
                        ? 'ticket_total'
                        : 'invoice_total'
                    data[tot] = data[tot] - data.changed_dte.dte.total
                    data['subtotalInvoice'] =
                        data[tot] - data.changed_dte.dte.total
                    this.setIsChangeTicket(true)
                    this.setPayer('SC')
                }
            }

            // FIXME: Remove in production
            this.setOfficeID(data.g_branch_office_id)
            if (JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS))
                Promise.all([
                    getIntegrationTicketNumber(),
                    getIntegrationInvoiceTicketNumber(),
                ])
                    .then(dt => {
                        this.setTicketCounter(dt[0])
                        this.setInvoiceTicketCounter(dt[1])
                    })
                    .catch(e => console.log(e))

            if (data.flag_delete != null) {
                if (data.flag_delete == false) {
                    switch (stateSaleId) {
                        case 17:
                            this.addSale(data)
                            break
                        case 18:
                            this.sendErrorMessage(stateSaleId)
                            if (this.multipleTicket) {
                                this.cleanFormMultiple()
                            } else {
                                this.cleanForm()
                            }
                            break
                        case 35:
                            this.sendErrorMessage(stateSaleId)
                            if (this.multipleTicket) {
                                this.cleanFormMultiple()
                            } else {
                                this.cleanForm()
                            }
                            break
                        case 19:
                            this.sendErrorMessage(stateSaleId)
                            if (this.multipleTicket) {
                                this.cleanFormMultiple()
                            } else {
                                this.cleanForm()
                            }
                            break
                    }
                } else {
                    const ErrorId = 1
                    this.sendErrorMessage(ErrorId)
                    this.cleanForm()
                }
            } else {
                const VentaEncontrada = 2
                this.sendErrorMessage(VentaEncontrada)
                this.cleanForm()
            }
            this.blockSearch = false
        },

        sendErrorMessage(stateSaleId) {
            const State = [
                {
                    id: 17,
                    status: 'Ok para realizar venta',
                    title: 'Ticket Valido',
                    type: 'error',
                },
                {
                    id: 18,
                    status: 'Venta Anulada por tiempo ó vendedor',
                    title: 'Ticket Anulado',
                    type: 'error',
                },
                {
                    id: 19,
                    status: 'Venta ya fue ejecutada',
                    title: 'Ticket Pagado',
                    type: 'info',
                },
                {
                    id: 35,
                    status: 'Venta pendiente de confirmación en despacho',
                    title: 'Venta por Confirmar',
                    type: 'info',
                },
                {
                    id: 1,
                    status: 'Venta Eliminada',
                    title: 'Ticket Eliminado',
                    type: 'warning',
                },
                {
                    id: 2,
                    status: 'Venta No Encontrada',
                    title: 'Ticket desconocido',
                    type: 'info',
                },
            ]
            const resultState = State.find(state => state.id == stateSaleId)

            let payload = {
                typeMessage: resultState.type,
                message: {
                    title: resultState.title,
                    body: resultState.status,
                },
                timeout: 0,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
            setTimeout(this.resetSnackbarState, 5000)
        },
        cleanForm() {
            this.ticketRead = ''
            this.ticketIsValid = false
            this.resetCashDeskState()
        },
        cleanFormMultiple() {
            this.chips = this.chips.slice(0, -1)
        },
        fillCostumer(slCostumer) {
            return {
                id: slCostumer.id,
                rut: slCostumer.rut,
                businessName: slCostumer.business_name,
                personName: slCostumer.alias_name,
                coreBusiness: slCostumer.core_business,
                address: slCostumer.address,
                phone: slCostumer.phone,
                email: slCostumer.email,
            }
        },
        cleanTicket() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack(CLEAN_TICKET)
            let payload = this.fillSnack(
                'warning',
                '¿Deseas limpiar venta?',
                'Todos los datos ingresados seran borrados'
            )
            this.initSnackbar(payload)
        },
        makeStr(len, char) {
            return Array.prototype.join.call(
                { length: (len || -1) + 1 },
                char || '0'
            )
        },
        handleBlur() {
            if (!this.ticketIsValid)
                this.$nextTick(() => this.$refs.ticketInput.focus())
        },
        /*
         */
        remove(item) {
            this.chips.splice(this.chips.indexOf(item), 1)
            this.chips = [...this.chips]
        },
        async removeChip(item) {
            let respMulti = await MultipleTicketTotalServices(
                this.currentIdMultiTicket
            )
            this.resetSaleAfterRemoveTicket(respMulti)
        },
        /*
         */
        getLastTicketAdded(arr) {
            return arr.slice(-1).pop()
        },
        /*
         */
        async addSale(data) {
            let totalLines = 0
            if (this.currentLines) {
                totalLines = data.pos_detail_sales.length + this.currentLines
            }

            if (
                this.posSaleType != null &&
                this.posSaleType != data.pos_sale_type_id
            ) {
                this.showMessageDifferentTicket(
                    this.posSaleType,
                    data.pos_sale_type_id
                )
            } else if (
                this.posSaleType == null ||
                (this.posSaleType == 1 &&
                    this.currentDiscountOrChargePercentage ==
                        data.discount_or_charge_percentage)
            ) {
                //save tickets in vuex array
                this.addMultipleSaleTicket(data)
                if (this.currentIdMultiTicket.length > 1) {
                    //si pago multiple
                    let respMulti = await MultipleTicketTotalServices(
                        this.currentIdMultiTicket
                    )
                    // console.log(respMulti,'response multi')
                    let ticketData = { ...data }
                    ticketData = this.reWriteTotalMultipleTickets(
                        ticketData,
                        respMulti
                    )
                    // console.log(data,'ticketData')
                    this.setSale(ticketData)
                } else {
                    //pago normal 1 ticket
                    this.setSale(data)
                }

                if (data.sl_customer) {
                    console.log('CUSTOMER', data.sl_customer)
                    this.setCustomerData(this.fillCostumer(data.sl_customer))
                    this.setCustomerPaymentConditionId(
                        data.sl_customer.pch_payment_condition_id
                    )
                    this.setCustomerReadonly(true)
                }
                this.ticketIsValid = true
                this.resetSnackbarState() //for closing progress snackbar
            } else if (
                this.posSaleType == 1 &&
                this.currentDiscountOrChargePercentage !=
                    data.discount_or_charge_percentage
            ) {
                this.resetSnackbarState()
                let snackInfo = this.fillSnack(
                    'warning',
                    `Ingreso No permitido(Descuentos diferentes)`,
                    `Descuento actual ${
                        this.currentDiscountOrChargePercentage
                    }%, descuento nuevo ${data.discount_or_charge_percentage}%`
                )
                this.initSnackbar(snackInfo)
            } else if (
                this.posSaleType == 2 &&
                totalLines <= 20 &&
                this.currentDiscountOrChargePercentage ==
                    data.discount_or_charge_percentage &&
                this.customerId == data.sl_customer_id
            ) {
                //save tickets in vuex array
                this.addMultipleSaleTicket(data)
                if (this.currentIdMultiTicket.length > 1) {
                    //si pago multiple
                    let respMulti = await MultipleTicketTotalServices(
                        this.currentIdMultiTicket
                    )
                    // console.log(respMulti,'response multi')
                    let ticketData = { ...data }
                    ticketData = this.reWriteTotalMultipleTickets(
                        ticketData,
                        respMulti
                    )
                    // console.log(data,'ticketData')
                    this.setSale(ticketData)
                } else {
                    //pago normal 1 ticket
                    this.setSale(data)
                }
                if (data.sl_customer) {
                    //this.setCustomerData(this.fillCostumer(data.sl_customer))
                }
                this.ticketIsValid = true
                this.resetSnackbarState() //for closing progress snackbar
            } else if (
                this.posSaleType == 2 &&
                totalLines > 20 &&
                this.currentDiscountOrChargePercentage ==
                    data.discount_or_charge_percentage &&
                this.customerId == data.sl_customer_id
            ) {
                this.resetSnackbarState()
                let snackInfo = this.fillSnack(
                    'warning',
                    `Ingreso Ticket No permitido`,
                    `Lineas al agregar ticket: ${totalLines} en Factura el máximo permitido son 20 lineas. Actuales: ${
                        this.currentLines
                    }`
                )
                this.initSnackbar(snackInfo)
            } else if (
                this.posSaleType == 2 &&
                totalLines <= 20 &&
                this.currentDiscountOrChargePercentage !=
                    data.discount_or_charge_percentage &&
                this.customerId == data.sl_customer_id
            ) {
                this.resetSnackbarState()
                let snackInfo = this.fillSnack(
                    'warning',
                    `Ingreso No permitido(Descuentos diferentes)`,
                    `Descuento actual ${
                        this.currentDiscountOrChargePercentage
                    }%, descuento nuevo ${data.discount_or_charge_percentage}%`
                )
                this.initSnackbar(snackInfo)
            } else if (
                this.posSaleType == 2 &&
                totalLines <= 20 &&
                this.currentDiscountOrChargePercentage ==
                    data.discount_or_charge_percentage &&
                this.customerId != data.sl_customer_id
            ) {
                this.resetSnackbarState()
                let snackInfo = this.fillSnack(
                    'warning',
                    `Ingreso No permitido(Clientes distintos)`,
                    `Pago multiple de ticket esta permitido para el mismo cliente`
                )
                this.initSnackbar(snackInfo)
            }
        },
        /*
         */
        checkExistIdInMultipleTicket(code) {
            let result = this.currentIdMultiTicket.find(r => r == code)
            return result != null ? true : false
        },
        submitBackendIdsSale() {},
        reWriteTotalMultipleTickets(ticket, multiplePaymentTicket) {
            let newTicket = ticket
            newTicket.ticket_total = multiplePaymentTicket.total
            newTicket.invoice_total = multiplePaymentTicket.total //verify it
            newTicket.new_net_subtotal = multiplePaymentTicket.new_net_subtotal
            newTicket.iva = multiplePaymentTicket.iva
            newTicket.discount_or_charge_percentage =
                multiplePaymentTicket.global_discount
            return newTicket
        },
        showMessageDifferentTicket(posSaleType, addTicketType) {
            const POS_SALES = [
                { id: 1, type: 'BOLETA' },
                { id: 2, type: 'FACTURA' },
            ]
            let ticketType = POS_SALES.find(ps => ps.id === addTicketType)
            let typeSale = POS_SALES.find(ps => ps.id === posSaleType)
            this.resetSnackbarState()
            let snackInfo = this.fillSnack(
                'warning',
                `Ingreso Ticket No permitido`,
                `Ticket ingresado ${ticketType.type} es diferente de tipo ${
                    typeSale.type
                } `
            )
            this.initSnackbar(snackInfo)
        },
        checkPrefixTicket(code) {
            const ALLOW_PREFIX = ['SC', 'SE', 'SX']
            let codePrefix = code.substr(0, 2)
            return ALLOW_PREFIX.some(
                p => p.toUpperCase() === codePrefix.toUpperCase()
            )
            //return prefix ? true : false
        },
    },
    watch: {
        responseConfirm: async function(val) {
            if (val == ANNUL_SALE_ACTION) {
                let snackInfo = this.fillSnack(
                    'info',
                    'Anulando Ticket',
                    'El Ticket esta siendo anulado',
                    true
                )
                this.initSnackbar(snackInfo)
                //payer
                //ticketCode
                let payloadAnnulSale = {
                    payer: this.payer,
                    ticketCode: this.ticketCode,
                }
                let response = await this.annulSale(payloadAnnulSale)
                this.resetSnackbarState()
                if (response.status == 'success') {
                    this.cleanForm()
                    let snackInfo = this.fillSnack(
                        'success',
                        'Anulación Exitosa',
                        'El Ticket ha sido anulado',
                        false,
                        5000
                    )
                    this.initSnackbar(snackInfo)
                } else {
                    let error =
                        response.error == null
                            ? response.message
                            : response.error
                    let snackInfo = this.fillSnack('error', 'ERROR', error)
                    this.initSnackbar(snackInfo)
                }
            } else if (val == CLEAN_TICKET) {
                this.resetSale()
                this.cleanForm()
                this.resetSnackbarState()
            }
        },
        ticketRead: function(val) {
            let prefix = ''
            // if (val.length >= 2) {
            //     prefix = val.substr(0, 2)
            //     if (prefix == 'SC' || prefix == 'SE') {
            //     } else {
            //         this.ticketRead = 'SC'
            //     }
            // } else if (val == '') {
            //     this.ticketRead = ''
            // }
        },
        multipleTicket(v) {
            this.setSwitchMultipleTicket(v)
        },
        /*
        multipleTicket: function(val) {
            if (val) {
                this.setSwitchMultipleTicket(val)
                this.ticketRead = ''
            } else {
                // TODO: reset cash desk
            }
        },
        */
    },
    components: {
        //ActionsMenu,
        'sale-detail': SaleDetails,
        Payment,
        'barcode-scanner-handler': BarcodeScannerHandler,
        'multiple-ticket': MultipleTicket,

        //'search-id-venta': SearchIdVenta,
    },
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},

    // FIXME: Remove in production
    // ENDFIXME

    // beforeMount: function(){...},
    mounted: function() {
        if (this.ticketCode != '') {
            let codeLength = this.ticketCode.toString().length
            let numberZeros = 12 - parseInt(codeLength)
            let zeros = this.makeStr(parseInt(numberZeros))
            this.ticketRead = this.payer + zeros + this.ticketCode
            this.ticketIsValid = true
        }
        if (!this.cash_desk_id)
            this.fetchCashDeskID()
                .then(console.log)
                .catch(console.log)
        document.getElementById('sale-ticket-input').focus()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
